// localStorage-based bookmark utility — no backend needed

const BOOKMARKS_KEY = "insights_bookmarks";

export interface BookmarkedPost {
  id: number;
  title: string;
  slug: string;
}

export function getBookmarkedPosts(): BookmarkedPost[] {
  try {
    const raw = localStorage.getItem(BOOKMARKS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function isPostBookmarked(id: number): boolean {
  return getBookmarkedPosts().some((p) => p.id === id);
}

export function toggleBookmark(post: BookmarkedPost): boolean {
  const current = getBookmarkedPosts();
  const exists = current.findIndex((p) => p.id === post.id);
  if (exists >= 0) {
    current.splice(exists, 1);
    localStorage.setItem(BOOKMARKS_KEY, JSON.stringify(current));
    return false; // removed
  } else {
    current.push(post);
    localStorage.setItem(BOOKMARKS_KEY, JSON.stringify(current));
    return true; // added
  }
}

export function getBookmarkedIds(): Set<number> {
  return new Set(getBookmarkedPosts().map((p) => p.id));
}
